import { render, staticRenderFns } from "./ComparisonPlanModalSection.vue?vue&type=template&id=200f4007&scoped=true"
import script from "./ComparisonPlanModalSection.vue?vue&type=script&lang=js"
export * from "./ComparisonPlanModalSection.vue?vue&type=script&lang=js"
import style0 from "./ComparisonPlanModalSection.vue?vue&type=style&index=0&id=200f4007&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f4007",
  null
  
)

export default component.exports